import { DeleteButton } from '@/core/components';

import { Id, useDelete } from '@feature/utils';

import { useLaboratoryDelete } from '../model/LaboratoryQuery';

interface LaboratoryDeleteButtonProps {
  laboratory: Id;
}

export function LaboratoryDeleteButton({ laboratory }: LaboratoryDeleteButtonProps) {
  const mutation = useLaboratoryDelete(laboratory);
  const deleteProps = useDelete({
    mutation,
    navigateTo: { to: '..' },
  });

  return (
    <DeleteButton
      miw="100px"
      size="xs"
      {...deleteProps}
    />
  );
}
